// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/img/login_bg_final.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/assets/img_Bus/CESL_Buses_imgBG2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_background__5FxCw {
  font-family: "Roboto", sans-serif;
  /* background-image: url("~/public/assets/img/login_bg_old.png"); */
  /* background-image: url("~/public/assets/img/login_bg_image.jpg"); */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  height: 100vh;
}
.Login_backgroundbus__Z1CWE {
  font-family: "Roboto", sans-serif;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  height: 100vh;
}
h1 {
  font-size: 2.2rem;
}
input,
.Login_btn__xo9Xs {
  height: 40px;
}
::-webkit-input-placeholder {
  /* Edge */
  color: #8e8e8e;
}

.Login_error__eYUfs {
  font-size: 14px;
  color: red;
  font-weight: 600;
}

::placeholder {
  color: #8e8e8e;
}

.Login_btn-primary__5vsLN {
  background-color: #358696 !important;
  border-color: #358696 !important;
}
.Login_btn-primary__5vsLN:hover,
.Login_btn-primary__5vsLN.Login_active__scVy9,
.Login_btn-primary__5vsLN:focus {
  background-color: #1b6b7a !important;
  outline: none !important;
  border-color: #358696 !important;
}

.Login_loginBg__C3TUe {
  background: linear-gradient(
    180deg,
    rgba(53, 134, 150, 0.5) 11.38%,
    rgba(255, 255, 255, 0) 50%
  );
}
.Login_ttlLogo__yQ9Eq {
  height: 36px !important;
}
.Login_nly_fo_tml__E1Qdh {
  height: 18px !important;
}
.Login_spargPlgLogo__UvzZE {
  height: 50px !important;
}
.Login_loginhold__\\+asiB .Login_loginSec__EU2GG {
  background: rgb(0 0 0 / 30%);
  border-radius: 20px;
  margin-right: 3.5rem;
}

.Login_loginSec__EU2GG h1 {
  color: #ffffff;
  font-size: 1.8em;
}

/* Media Queries */
@media screen and (max-width: 768px) {
  .Login_loginSec__EU2GG .Login_form-control__QurK0 {
    font-size: 0.825rem;
  }
  .Login_loginSec__EU2GG h1 {
    font-size: 1.5em;
  }
}
@media screen and (max-width: 480px) {
  .Login_loginhold__\\+asiB .Login_loginSec__EU2GG {
    margin-right: 0;
  }
  .Login_loginSec__EU2GG .Login_form-control__QurK0 {
    font-size: 0.825rem;
  }
}

.Login_work_in_progress_img__i-CM7 {
  /* background-image: url("~/public/assets/img/work_in_progress.png") ; */
  position: absolute;
  left: 4px;
  width: 33px;
  height: 33px;
  top: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Login/Login.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,mEAAmE;EACnE,qEAAqE;EACrE,yDAA+D;EAC/D,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,iCAAiC;EACjC,yDAAsE;EACtE,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,YAAY;AACd;AACA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAOA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;EAGE,oCAAoC;EACpC,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE;;;;GAIC;AACH;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,wEAAwE;EACxE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,QAAQ;AACV","sourcesContent":[".background {\r\n  font-family: \"Roboto\", sans-serif;\r\n  /* background-image: url(\"~/public/assets/img/login_bg_old.png\"); */\r\n  /* background-image: url(\"~/public/assets/img/login_bg_image.jpg\"); */\r\n  background-image: url(\"~/public/assets/img/login_bg_final.jpg\");\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: cover;\r\n  position: relative;\r\n  height: 100vh;\r\n}\r\n.backgroundbus {\r\n  font-family: \"Roboto\", sans-serif;\r\n  background-image: url(\"~/public/assets/img_Bus/CESL_Buses_imgBG2.png\");\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: cover;\r\n  position: relative;\r\n  height: 100vh;\r\n}\r\nh1 {\r\n  font-size: 2.2rem;\r\n}\r\ninput,\r\n.btn {\r\n  height: 40px;\r\n}\r\n::-webkit-input-placeholder {\r\n  /* Edge */\r\n  color: #8e8e8e;\r\n}\r\n\r\n.error {\r\n  font-size: 14px;\r\n  color: red;\r\n  font-weight: 600;\r\n}\r\n\r\n:-ms-input-placeholder {\r\n  /* Internet Explorer 10-11 */\r\n  color: #8e8e8e;\r\n}\r\n\r\n::placeholder {\r\n  color: #8e8e8e;\r\n}\r\n\r\n.btn-primary {\r\n  background-color: #358696 !important;\r\n  border-color: #358696 !important;\r\n}\r\n.btn-primary:hover,\r\n.btn-primary.active,\r\n.btn-primary:focus {\r\n  background-color: #1b6b7a !important;\r\n  outline: none !important;\r\n  border-color: #358696 !important;\r\n}\r\n\r\n.loginBg {\r\n  background: linear-gradient(\r\n    180deg,\r\n    rgba(53, 134, 150, 0.5) 11.38%,\r\n    rgba(255, 255, 255, 0) 50%\r\n  );\r\n}\r\n.ttlLogo {\r\n  height: 36px !important;\r\n}\r\n.nly_fo_tml {\r\n  height: 18px !important;\r\n}\r\n.spargPlgLogo {\r\n  height: 50px !important;\r\n}\r\n.loginhold .loginSec {\r\n  background: rgb(0 0 0 / 30%);\r\n  border-radius: 20px;\r\n  margin-right: 3.5rem;\r\n}\r\n\r\n.loginSec h1 {\r\n  color: #ffffff;\r\n  font-size: 1.8em;\r\n}\r\n\r\n/* Media Queries */\r\n@media screen and (max-width: 768px) {\r\n  .loginSec .form-control {\r\n    font-size: 0.825rem;\r\n  }\r\n  .loginSec h1 {\r\n    font-size: 1.5em;\r\n  }\r\n}\r\n@media screen and (max-width: 480px) {\r\n  .loginhold .loginSec {\r\n    margin-right: 0;\r\n  }\r\n  .loginSec .form-control {\r\n    font-size: 0.825rem;\r\n  }\r\n}\r\n\r\n.work_in_progress_img {\r\n  /* background-image: url(\"~/public/assets/img/work_in_progress.png\") ; */\r\n  position: absolute;\r\n  left: 4px;\r\n  width: 33px;\r\n  height: 33px;\r\n  top: 2px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `Login_background__5FxCw`,
	"backgroundbus": `Login_backgroundbus__Z1CWE`,
	"btn": `Login_btn__xo9Xs`,
	"error": `Login_error__eYUfs`,
	"btn-primary": `Login_btn-primary__5vsLN`,
	"active": `Login_active__scVy9`,
	"loginBg": `Login_loginBg__C3TUe`,
	"ttlLogo": `Login_ttlLogo__yQ9Eq`,
	"nly_fo_tml": `Login_nly_fo_tml__E1Qdh`,
	"spargPlgLogo": `Login_spargPlgLogo__UvzZE`,
	"loginhold": `Login_loginhold__+asiB`,
	"loginSec": `Login_loginSec__EU2GG`,
	"form-control": `Login_form-control__QurK0`,
	"work_in_progress_img": `Login_work_in_progress_img__i-CM7`
};
export default ___CSS_LOADER_EXPORT___;
